@if (profileField$ | async; as profileField) {
    <dt [id]="profileField.FieldDefinition.FlatKey" class="sh-description-list__term" style="{{ nestedPadding$ | async }}">
        <sh-field-label [label]="profileField.DisplayLabel" [labelIcons]="$labelIcons()"></sh-field-label>
    </dt>
    @if (value$ | async; as value) {
        <dd class="sh-description-list__details sh-preserve-linebreaks -sh-overflow-scrolling">{{ value }}</dd>
    } @else {
        <dd class="sh-description-list__details">-</dd>
    }
}
